import { createSlice } from '@reduxjs/toolkit';
import { createDefaultFetch } from 'types/rest/IFetchStatus';
import { IStandardDocument } from '../../../types/order/documents/shared/interfaces';

export const finalizePoliciesSlice = createSlice({
  name: 'finalizePolicies',
  initialState: {
    fetchErrors: [] as Error[],
    fetchStatus: createDefaultFetch(),
    feesCount: 0,
    policyDocuments: [] as IStandardDocument[],
    sendErrors: [] as Error[],
    sendStatus: createDefaultFetch(),
  },
  reducers: {
    addFetchError: (state, action) => {
      state.fetchErrors = [...state.fetchErrors, action.payload];
    },
    setFetchStatus: (state, action) => {
      state.fetchStatus = action.payload;
    },
    setFeesCount: (state, action) => {
      state.feesCount = action.payload;
    },
    setPolicyDocuments: (state, action) => {
      state.policyDocuments = action.payload;
    },
    addSendError: (state, action) => {
      state.sendErrors = [...state.sendErrors, action.payload];
    },
    setSendStatus: (state, action) => {
      state.sendStatus = action.payload;
    },
  },
});

export const { addFetchError, addSendError, setFeesCount, setFetchStatus, setSendStatus, setPolicyDocuments } =
  finalizePoliciesSlice.actions;
